import gql from 'graphql-tag'

export const datoState = gql`
  query DatoState($locale: SiteLocale) {
    _site(locale: $locale) {
      globalSeo {
        siteName
        fallbackSeo {
          description
          title
          image {
            url(imgixParams: { w: "1200", h: "630" })
          }
          twitterCard
        }
        titleSuffix
      }
    }
    corporate(locale: $locale) {
      id
      generalInfo
    }
    navigation(locale: $locale) {
      id
      ctaLabel
    }
  }
`
